// Hooks
import { useRef, useEffect } from 'react';

// Next
import Link from 'next/link';

// Analytics
import { analyticsClient } from '../../client/analytics';

const CaseItem = (props) => {
  const {
    fields: { slug, title, client, caseLinkLabel },
  } = props;
  const ref = useRef();

  useEffect(() => {
    analyticsClient.trackLink(ref.current, '[All case studies] Case study clicked', {
      slug,
    });
  }, []);

  return (
    <Link as={`/cases/${slug}`} href="/cases/[slug]">
      <a className="CaseItem" ref={ref}>
        <div className="CaseItem-image">
          <img src={client.fields.logoDeepPurple.fields.file.url} alt={client.fields.name} />
        </div>
        <h3 className="CaseItem-title">{title}</h3>
        <div className="CaseItem-story">
          <span className="CaseItem-label">{caseLinkLabel || `Listen to ${client.fields.name} story`}</span>
          <svg className="CaseItem-icon">
            <use xlinkHref="#arrow-next" />
          </svg>
        </div>
      </a>
    </Link>
  );
};

export default CaseItem;
